/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheBorder} from "../TheBorder";


export class TheBorderIdleNormalPresentation implements FlowStatePresentation {

    constructor() {    }

    public start(flowStateController: FlowStateController): void {
        // Check to show FS/SUPER FS outro
        TheBorder.clusterWinView.hideAll();
        if (!(TheBorder.autoPlayPlugin.isAutoplayRound)) {
            TheBorder.xRipButton.enableButton(true, 0.3);
            TheBorder.xRipButton.playHighLightSparks();
        }

        flowStateController.finish();
    }


}